import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  SET_MERCHANT_EDIT_INFO,
  SUPERADMIN_VENDOR_SEATING_DINER,
  SUPERADMIN_VENDOR_PENDING_DINER,
  SUPERADMIN_VENDOR_RESERVATION_DINER,
  SUPERADMIN_VENDOR_HISTORY_DINER,
  SET_VENDOR_INFORMATION,
  ADMIN_ONBOARD_SET_RESTAURANT_DETAILS,
} from "../../types";

import Alert from "react-s-alert";

import { setErrors } from "../errorActions";
import { serverApi } from "../../../config/Keys";

/***************************************
 * @DESC - GET ALL VENDOR SEATING INFO
 *****************************************/
export const get_all_vendor_seating_information =
  (data, callback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_vendors_diners_info = await axios.get(
        `${serverApi}/diner?vendor_id=${data.vendor_id}&diner_status=SEATING`
      );
      if (get_vendors_diners_info.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_VENDOR_SEATING_DINER,
          payload: get_vendors_diners_info.data.data,
        });
        dispatch(get_all_vendor_pending_information(data));
        dispatch(get_all_vendor_reservation_information(data));
        dispatch(get_all_vendor_history_information(data));
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/************************************************
 * @DESC - GET PERTICULAR VENDOR RESTAURANT INFO
 ***********************************************/
export const get_single_vendor_restaurant_information =
  (token, vendorId, callback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_vendors_single_diners_info = await axios.get(
        `${serverApi}/searchRestaurant?vendor_id=${vendorId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_vendors_single_diners_info.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SET_MERCHANT_EDIT_INFO,
          payload: get_vendors_single_diners_info.data,
        });
        dispatch({
          type: ADMIN_ONBOARD_SET_RESTAURANT_DETAILS,
          payload: get_vendors_single_diners_info.data,
        });
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET ALL VENDOR SEATING INFO
 *****************************************/
export const get_all_vendor_pending_information =
  (data, callback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_vendors_pending_info = await axios.get(
        `${serverApi}/diner?vendor_id=${data.vendor_id}&diner_status=PENDING`
      );
      if (get_vendors_pending_info.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_VENDOR_PENDING_DINER,
          payload: get_vendors_pending_info.data.data,
        });
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET ALL VENDOR SEATING INFO
 *****************************************/
export const get_all_vendor_reservation_information =
  (data, callback, custom_time) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_vendors_reservation_info = await axios.get(
        `${serverApi}/diner?vendor_id=${
          data.vendor_id
        }&diner_status=RESERVATION&${
          custom_time === undefined
            ? ""
            : `customTime=${custom_time}` && custom_time === true
            ? `openAll=${custom_time}`
            : `customTime=${custom_time}`
        }`
      );
      if (get_vendors_reservation_info.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_VENDOR_RESERVATION_DINER,
          payload: get_vendors_reservation_info.data.data,
        });
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET ALL VENDOR SEATING INFO
 *****************************************/
export const get_all_vendor_history_information =
  (data, callback) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_vendors_history_info = await axios.get(
        `${serverApi}/diner?vendor_id=${data.vendor_id}&diner_status=HISTORY`
      );
      if (get_vendors_history_info.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_VENDOR_HISTORY_DINER,
          payload: get_vendors_history_info.data.data,
        });
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - SUPER ADMIN VENDOR SET WAIT TIME
 *****************************************/
export const superadmin_set_wait_time_update =
  (formData) => async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      let add_restaurant_data = await axios.post(
        `${serverApi}/restaurant`,
        formData
      );
      if (add_restaurant_data.status === 201) {
        dispatch({
          type: SET_VENDOR_INFORMATION,
          payload: add_restaurant_data.data.restaurant,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - SUPER ADMIN DINER SEATED ACTION
 *****************************************/
export const super_admin_diner_status_change =
  (
    formData,
    diner_id,
    // vendor_id,
    token
    // onCallBackFunc
  ) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let seatedWaitTime = await axios.patch(
        `${serverApi}/admin/diner/${diner_id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(seatedWaitTime);
      if (seatedWaitTime.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Diner Record Update Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        // onCallBackFunc();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const super_admin_diner_status_change_test =
  (
    formData,
    diner_id,
    // vendor_id,
    token,
    onCallBackFunc
  ) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let seatedWaitTime = await axios.patch(
        `${serverApi}/admin/diner/${diner_id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(seatedWaitTime.data);
      if (seatedWaitTime.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Diner Record Update Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        // onCallBackFunc();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - SUPER ADMIN MARK ALL COMPLETED
 *****************************************/
export const super_admin_mark_all_completed_diner =
  (formData, vendor_id, token, onCallBackFunc) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let admin_mark_all_completed = await axios.patch(
        `${serverApi}/admin/diner?markComplete=${formData.markComplete}&vendor_id=${vendor_id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(admin_mark_all_completed);
      if (admin_mark_all_completed.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Diners Records Completed Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onCallBackFunc();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
